import http from './http';

export const authApi = {
  login(data) {
    return http.post('/api/auth/login', data);
  },
  me() {
    return http.get('/api/auth/me');
  }
};

export const dashboardApi = {
  summary() {
    return http.get('/api/dashboard/summary');
  }
};

export const userApi = {
  list(params = {}) {
    return http.get('/api/users', { params });
  },
  create(data) {
    return http.post('/api/users', data);
  },
  update(id, data) {
    return http.put(`/api/users/${id}`, data);
  },
  updateStatus(id, status) {
    return http.put(`/api/users/${id}/status`, { status });
  },
  resetPassword(id) {
    return http.put(`/api/users/${id}/password/reset`);
  }
};

export const promptApi = {
  list(params = {}) {
    return http.get('/api/prompts', { params });
  },
  create(data) {
    return http.post('/api/prompts', data);
  },
  update(id, data) {
    return http.put(`/api/prompts/${id}`, data);
  },
  remove(id) {
    return http.delete(`/api/prompts/${id}`);
  }
};

export const variationTemplateApi = {
  list(params = {}) {
    return http.get('/api/variation-templates', { params });
  },
  detail(id) {
    return http.get(`/api/variation-templates/${id}`);
  },
  create(data) {
    return http.post('/api/variation-templates', data);
  },
  update(id, data) {
    return http.put(`/api/variation-templates/${id}`, data);
  },
  remove(id) {
    return http.delete(`/api/variation-templates/${id}`);
  }
};

export const fileApi = {
  upload(file) {
    const formData = new FormData();
    formData.append('file', file);
    return http.post('/api/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  uploadBatch(files = []) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    return http.post('/api/files/upload-batch', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

export const productApi = {
  list(params = {}) {
    return http.get('/api/products', { params });
  },
  detail(id) {
    return http.get(`/api/products/${id}`);
  },
  create(data) {
    return http.post('/api/products', data);
  },
  update(id, data) {
    return http.put(`/api/products/${id}`, data);
  },
  remove(id) {
    return http.delete(`/api/products/${id}`);
  },
  generateDescription(id, data) {
    return http.post(`/api/products/${id}/generate-description`, data);
  },
  getEtsyVariationMetadata(id) {
    return http.get(`/api/products/${id}/etsy-variation-metadata`);
  },
  applyAiResult(id, data = {}) {
    return http.post(`/api/products/${id}/apply-ai-result`, data);
  },
  publishToEtsyDraft(id) {
    return http.post(`/api/products/${id}/publish-etsy-draft`);
  },
  async exportCsv(ids) {
    const response = await http.post('/api/products/export', { ids }, {
      responseType: 'blob'
    });
    return response;
  },
  logs(params = {}) {
    return http.get('/api/logs', { params });
  },
  logDetail(logId) {
    return http.get(`/api/logs/${logId}`);
  }
};

export const settingsApi = {
  getAiConfig() {
    return http.get('/api/settings/ai');
  },
  saveAiConfig(data) {
    return http.put('/api/settings/ai', data);
  },
  getEtsyAuthUrl() {
    return http.get('/api/settings/etsy/auth-url');
  },
  disconnectEtsy() {
    return http.post('/api/settings/etsy/disconnect');
  }
};

export const etsyApi = {
  listSections() {
    return http.get('/api/integrations/etsy/sections');
  },
  listShippingProfiles() {
    return http.get('/api/integrations/etsy/shipping-profiles');
  },
  listListings(params = {}) {
    return http.get('/api/integrations/etsy/listings', { params });
  },
  listingDetail(listingId) {
    return http.get(`/api/integrations/etsy/listings/${listingId}`);
  }
};
